'use strict';
window.uomedia = window.uomedia || {};

(($) => {
  $('.search-filters').on('click', 'a', function (event) {
    event.preventDefault();
    const $this = $(this);
    const $ajaxBtn = $('a[data-ajax]');
    const filter = $this.attr('href').split('#')[1];
    $('.search-filters a').removeClass('selected');
    $this.addClass('selected');
    if (filter !== "all") {
      $('article[data-post-type!="' + filter + '"]').parent().hide();
      $('article[data-post-type="' + filter + '"]').parent().show();
    } else {
      $('article').parent().show();
    }
    const hasMore = document.querySelectorAll('.search-results .col-12:not([style="display: none;"])').length > 10;
    if (hasMore) {
      $ajaxBtn.show();
    } else {
      $ajaxBtn.hide();
    }
  });
})(jQuery);
